import type { RouteRecord } from 'vite-react-ssg';
import Root from '@/Root';
import App from '@/App';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import NotFound from '@/pages/NotFound';
import ServicePage from '@/pages/services/ServicePage';
import SubServicePage from '@/pages/services/SubServicePage';
import AdminLogin from '@/pages/admin/Login';
import AdminDashboard from '@/pages/admin/Dashboard';
import AdminQuotes from '@/pages/admin/Quotes';
import AdminQuoteDetail from '@/pages/admin/QuoteDetail';
import AdminEmailTemplates from '@/pages/admin/EmailTemplates';
import SuperEvents from '@/pages/admin/super/Events';
import SuperLoginAttempts from '@/pages/admin/super/LoginAttempts';
import SuperAudit from '@/pages/admin/super/Audit';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { ProtectedRoute } from '@/lib/auth';
import { services } from '@/data/services';

const wrap = (C: React.ComponentType) => () => (
  <ProtectedRoute>
    <C />
  </ProtectedRoute>
);

export const routes: RouteRecord[] = [
  {
    path: '/',
    Component: Root,
    children: [
      {
        path: '',
        Component: App,
        children: [
          { index: true, Component: Home, entry: 'src/pages/Home.tsx' },
          { path: 'about', Component: About, entry: 'src/pages/About.tsx' },
          { path: 'contact', Component: Contact, entry: 'src/pages/Contact.tsx' },
          {
            path: ':service',
            Component: ServicePage,
            entry: 'src/pages/services/ServicePage.tsx',
            getStaticPaths: () => services.map((s) => `/${s.slug}`),
          },
          {
            path: ':service/:sub',
            Component: SubServicePage,
            entry: 'src/pages/services/SubServicePage.tsx',
            getStaticPaths: () =>
              services.flatMap((s) => s.subservices.map((sub) => `/${s.slug}/${sub.slug}`)),
          },
          // Pre-rendered so Apache can serve a real 404 page with a 404
          // status (ErrorDocument /404.html) instead of a soft-404.
          { path: '404', Component: NotFound, entry: 'src/pages/NotFound.tsx' },
          { path: '*', Component: NotFound },
        ],
      },
      // Admin tree - NOT pre-rendered (no `entry`), client-side only.
      { path: 'admin/login', Component: AdminLogin },
      {
        path: 'admin',
        Component: AdminLayout,
        children: [
          { index: true, Component: wrap(AdminDashboard) },
          { path: 'quotes', Component: wrap(AdminQuotes) },
          { path: 'quotes/:id', Component: wrap(AdminQuoteDetail) },
          { path: 'email-templates', Component: wrap(AdminEmailTemplates) },
          { path: 'super/events', Component: wrap(SuperEvents) },
          { path: 'super/login-attempts', Component: wrap(SuperLoginAttempts) },
          { path: 'super/audit', Component: wrap(SuperAudit) },
        ],
      },
    ],
  },
];
